PegasusTemplate.ActivePortionControlMixin = Em.Mixin.create({
  topActive: false
});
